/* global Temporal */

// detect the user's timezone and set a cookie for temporal-rails
// so that Time.zone is scoped to the user's timezone
if (window.Temporal) {
  Temporal.detect();
}



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/temporal.js